'use client';

import { useEffect, useRef, useState } from 'react';

export const useHumanInteraction = () => {
  const [isHumanInteraction, setIsHumanInteraction] = useState(false);
  const lastMousePositionRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const lastPos = lastMousePositionRef.current;

      if (
        Math.abs(e.clientX - lastPos.x) > 5 ||
        Math.abs(e.clientY - lastPos.y) > 5
      ) {
        setIsHumanInteraction(true);
      }

      lastMousePositionRef.current = { x: e.clientX, y: e.clientY };
    };

    document.addEventListener('mousemove', handleMouseMove);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return isHumanInteraction;
};
